import parseHtml from "@utils/parseHtml";
import { $, $$ } from "@utils/select";

export default ({ empty, total }) => ({
  empty,
  total,
  open: false,
  hasError: false,
  error: "",
  isInitialized: false,
  termsAccepted: false,
  showNote: false,
  lineLoading: null,
  loading: false,
  timeoutQuantity: null,
  timeoutNote: null,
  items: [],

  init() {
    this.isInitialized = true;
    this.items = this.getItemData();
    this.showNote = this.$refs.note.value;

    if (window.location.hash === "#cart") {
      this.open = true;
    }
  },

  getItemData() {
    const $$items = $$('[x-ref="item"]');
    if (!$$items.length) return [];
    return $$items.map((item) => ({
      quantity: parseInt(item.dataset.quantity),
      error: "",
    }));
  },

  termsChange() {
    if (this.termsAccepted) {
      this.hasError = false;
      this.error = "";
    }
  },

  async updateQuantity(quantity, line) {
    clearTimeout(this.timeoutQuantity);
    this.timeoutQuantity = setTimeout(async () => {
      this.lineLoading = line;
      const response = await fetch(window.routes.cart_change_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: `application/json`,
        },
        body: JSON.stringify({
          line,
          quantity,
          sections: ["cart-bubble", "cart-drawer"],
          sections_url: window.location.pathname,
        }),
      });

      if (response.status !== 200) {
        this.lineLoading = null;
        this.error = window.cartStrings.error;
        this.hasError = true;
      } else {
        this.hasError = false;
        this.error = "";
      }

      const json = await response.json();
      this.$dispatch("updatebubble", json.sections["cart-bubble"]);
      this.updateCart({ detail: json.sections["cart-drawer"] }, line);

      this.$nextTick(() => {
        this.lineLoading = null;
      });
    }, 300);
  },

  updateCart({ detail }, line = null) {
    const $dom = parseHtml(detail);
    const $form = $('[x-ref="form"]', $dom);
    this.empty = $form.hasAttribute("data-empty");

    if (this.empty) {
      this.empty = true;
      return;
    }

    this.$refs.form.parentNode.replaceChild($form, this.$refs.form);

    this.$nextTick(() => {
      const newItems = this.getItemData();
      const item = newItems[line - 1];

      if (line && item && item.quantity === this.items[line - 1].quantity) {
        item.error = window.cartStrings.quantityError.replace(
          "[quantity]",
          item.quantity
        );
      }

      this.items = newItems;
    });
  },

  updateNote() {
    clearTimeout(this.timeoutNote);
    this.timeoutNote = setTimeout(() => {
      fetch(window.routes.cart_update_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: `application/json`,
        },
        body: JSON.stringify({
          note: this.$refs.note.value,
        }),
      });
    }, 300);
  },

  handleSubmit(e) {
    if (!this.termsAccepted) {
      e.preventDefault();
      this.error = window.cartStrings.termsError;
      this.hasError = true;
      return false;
    }

    this.loading = true;
    // this.$refs.form.submit();
    return true;
  },
});
